module.exports = __webpack_public_path__ + "img/os-logo.296364b9.png";